import logo from './logo.svg';
import './App.css';
import MainPage from './Components/MainPage';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <MainPage/>
      </header>
    </div>
  );
}

export default App;
